import { render } from "./ReportFilesList.vue?vue&type=template&id=4196cb2e"
import script from "./ReportFilesList.vue?vue&type=script&lang=js"
export * from "./ReportFilesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__